angular
	.module 'App.Repository'
	.factory 'TicketEventSessionRepository', ['BaseRepository', (BaseRepository) ->
		class TicketEventSessionRepository extends BaseRepository
			@resource = '/ticket_event_sessions'
			@isRestricted = true

			getTicketCounts: (ticketEventId = null) ->
				query = @createQuery()

				if !_.isEmpty ticketEventId
					query.addParameter 'ticket_event_id', ticketEventId

				@findByQuery(query, '/count/tickets')
					.then (response) -> return response.data
					.catch -> return []

		return new TicketEventSessionRepository
	]
